import React, { Component } from "react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import moment from "moment-timezone";
import SportaTournamentRow from "./SportaTournamentRow";
import HeaderBar from "../../components/header/HeaderBar";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

class SportaAdminContainer extends Component {
  state = {
    upgrades: [],
    upgradesLoaded: false,
    tournaments: {},
    tournamentsLoaded: false,
    statusTournaments: {},
    statusLoaded: false,
    users: [],
  };

  UNSAFE_componentWillMount = () => {
    window.firebase
      .firestore()
      .collection("upgrades")
      .where("isSporta", "==", true)
      .onSnapshot((querySnapshot) => {
        let upgrades = [];
        querySnapshot.forEach((doc) => {
          let upgrade = doc.data();
          upgrade["id"] = doc.id;
          upgrade["created"] = moment(upgrade.timestamp.toDate()).unix();
          upgrades.push(upgrade);
        });
        this.setState({ upgrades: upgrades, upgradesLoaded: true });
      });

    window.firebase
      .firestore()
      .collection("tournaments")
      .where("isSporta", "==", true)
      .onSnapshot((querySnapshot) => {
        let tournaments = {};
        querySnapshot.forEach((doc) => {
          let tournament = doc.data();
          tournament["id"] = doc.id;
          tournaments[doc.id] = tournament;
        });
        this.setState({ tournaments: tournaments, tournamentsLoaded: true });
      });

    window.firebase
      .firestore()
      .collection("tournamentStatus")
      .where("isSporta", "==", true)
      .onSnapshot((querySnapshot) => {
        let statusTournaments = {};
        querySnapshot.forEach((doc) => {
          let tournamentStatus = doc.data();
          tournamentStatus["id"] = doc.id;
          statusTournaments[doc.id] = tournamentStatus;
        });
        this.setState({
          statusTournaments: statusTournaments,
          statusLoaded: true,
        });
      });

    window.firebase
      .firestore()
      .collection("users")
      .where("isSporta", "==", true)
      .get()
      .then((querySnapshot) => {
        let users = [];
        querySnapshot.forEach((doc) => {
          let user = doc.data();
          user["id"] = doc.id;
          users.push(user);
        });
        this.setState({
          users: users.sort((a, b) => {
            return b.registeredOn - a.registeredOn;
          }),
        });
      });
  };

  render() {
    let everyThingLoaded =
      this.state.upgradesLoaded &&
      this.state.tournamentsLoaded &&
      this.state.statusLoaded;
    let perYearPerQuarter = {};
    this.state.upgrades.forEach((upgrade) => {
      //   let status = this.state.statusTournaments[upgrade.tournamentId] || {};
      let year = moment.unix(upgrade.created).year();
      let quarter = moment.unix(upgrade.created).quarter();

      if (perYearPerQuarter[year] === undefined) {
        perYearPerQuarter[year] = {};
      }
      if (perYearPerQuarter[year][quarter] === undefined) {
        perYearPerQuarter[year][quarter] = {
          list: [],
          amount: 0,
        };
      }
      if (upgrade.payed) {
        perYearPerQuarter[year][quarter]["list"].push(upgrade);
        perYearPerQuarter[year][quarter]["amount"] += Number(upgrade.price);
      }
    });

    return (
      <div>
        <HeaderBar user={this.props.user} />
        <div style={{ width: "100%", marginTop: 100, padding: 15 }}>
          {everyThingLoaded &&
            Object.keys(perYearPerQuarter).map((yearKey) => {
              return (
                <ExpansionPanel
                  key={yearKey}
                  defaultExpanded={true}
                  style={{ width: "100%" }}
                >
                  <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography
                      variant="body2"
                      style={{ fontWeight: 500, paddingLeft: 1 }}
                    >
                      {yearKey}
                    </Typography>
                  </ExpansionPanelSummary>
                  <ExpansionPanelDetails
                    style={{ width: "100%", flexWrap: "wrap" }}
                  >
                    {Object.keys(perYearPerQuarter[yearKey]).map(
                      (quarterKey) => {
                        return (
                          <ExpansionPanel
                            key={yearKey}
                            defaultExpanded={true}
                            style={{ width: "100%" }}
                          >
                            <ExpansionPanelSummary
                              expandIcon={<ExpandMoreIcon />}
                            >
                              <Typography
                                variant="body2"
                                style={{ fontWeight: 500, paddingLeft: 1 }}
                              >
                                {"Kwartaal " + quarterKey}
                                <br />
                                {"€" +
                                  perYearPerQuarter[yearKey][quarterKey].amount}
                              </Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails
                              style={{ width: "100%", overflowX: "scroll" }}
                            >
                              <Table>
                                <TableHead>
                                  <TableRow>
                                    <TableCell>Datum</TableCell>
                                    <TableCell>Pakket</TableCell>
                                    <TableCell>Naam</TableCell>
                                    <TableCell>Livelink</TableCell>
                                  </TableRow>
                                </TableHead>

                                <TableBody>
                                  {perYearPerQuarter[yearKey][
                                    quarterKey
                                  ].list.map((upgrade) => {
                                    return (
                                      <SportaTournamentRow
                                        key={upgrade.id}
                                        user={this.props.user}
                                        upgrade={upgrade}
                                        isTournifyAdmin={
                                          this.props.isTournifyAdmin
                                        }
                                        tournamentStatus={
                                          this.state.statusTournaments[
                                            upgrade.tournamentId
                                          ] || {}
                                        }
                                        tournament={
                                          this.state.tournaments[
                                            upgrade.tournamentId
                                          ] || {}
                                        }
                                      />
                                    );
                                  })}
                                </TableBody>
                              </Table>
                            </ExpansionPanelDetails>
                          </ExpansionPanel>
                        );
                      }
                    )}
                  </ExpansionPanelDetails>
                </ExpansionPanel>
              );
            })}
        </div>
        <div style={{ margin: "0 15px" }}>Gekoppelde accounts:</div>
        <Table>
          <TableBody>
            {this.state.users.map((user) => (
              <TableRow key={user.id}>
                <TableCell>
                  {moment.unix(user.registeredOn).format("D MMMM YYYY HH:mm")}
                </TableCell>
                <TableCell>{user.firstName || ""}</TableCell>
                <TableCell>{user.email}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    );
  }
}

export default SportaAdminContainer;
